import React, { useState, useEffect, useRef } from 'react';
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import { DownloadOutlined, TableChartOutlined } from "@mui/icons-material";
import { Box, Button, useTheme, useMediaQuery, IconButton, Tooltip } from "@mui/material";
import { Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper,} from '@mui/material';
import { ContentCopy } from "@mui/icons-material"; // Import the copy icon
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { IoSend } from "react-icons/io5";
import { FaRobot } from "react-icons/fa";
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from "remark-gfm";

// GPT History table
import { DataGrid } from "@mui/x-data-grid";
import { useGetChatMessagesQuery } from "state/api";

import DataGridCustomToolbar from "components/DataGridCustomToolbar";

// Import provider
import { useGPTData } from 'providers/GPTDataProvider'
import "./Chatbot.css";

let HOST_URL = "https://s1.bioengineai.com";

const sendCytoAPI = async (currentMessage) => {
  let username = "quorra";

  console.log("\nClient::sendCytoAPI called: ", username, currentMessage);
  const res = await axios.post(HOST_URL + "/openai/ask", {
    message: currentMessage,
    username: username,
  });
	return res.data;
};

const CytoGPT = () => {
  const theme = useTheme();
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
  // add chatbot codes here

    // GPT History values to be sent to the backend
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [sort, setSort] = useState({});
    const [search, setSearch] = useState("");
  
    const [searchInput, setSearchInput] = useState("");
    // const { data, isLoading } = useGetDashboardQuery();
    const { data, isLoading } = useGetChatMessagesQuery({
      page,
      pageSize,
      sort: JSON.stringify(sort),
      search,
    });
  
      
    const columns = [
      {
        field: "_id",
        headerName: "ID",
        flex: 1,
      },
      {
        field: "username",
        headerName: "User ID",
        flex: 1,
      },
      {
        field: "userMessage",
        headerName: "Query",
        flex: 1,
      },
      {
        field: "botResponse",
        headerName: "Response",
        flex: 1,
      },
      {
        field: "timestamp",
        headerName: "CreatedAt",
        flex: 1,
      },
    ];
  

  const { message, isAITyping, conversation,
    setMessage, setIsAITyping, setConversation,
  } = useGPTData();
  
  const conversationRef = useRef(null); // Ref to the conversation div
  const [copiedMessage, setCopiedMessage] = useState(null); // State for tooltip
  const [chatHistory, setChatHistory] = useState([]);
  const [showHistoryTable, setShowHistoryTable] = useState(false);

  useEffect(() => {
    if (conversationRef.current) {
      conversationRef.current.scrollTo({
        top: conversationRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [conversation]);

	const mutation = useMutation({
	  mutationFn: sendCytoAPI,  // sendMessageAPI
    onSuccess: (data) => {
		setIsAITyping(false); // Stop showing AI typing when response arrives
		setConversation((prevConversation) => [
      ...prevConversation,
      { role: "assistant", content: data.message },
		]);
		console.log("frontend-src-pages::sendCytoAPI::mutation's data: ", data)
    },
	});

	const handleSendMessage = () => {
		// const currentMessage = message.trim();
		const currentMessage = message;
		if (!currentMessage) {
      alert("Please enter a message.");
      return;
		}
		setConversation((prevConversation) => [
      ...prevConversation,
      { role: "user", content: currentMessage },
		]);
		setIsAITyping(true); // Show AI is typing as soon as the message is sent
		mutation.mutate(currentMessage); // Removed redundant onSuccess here
		setMessage(""); // Clear the input after sending
  };

  // add copy content button
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text); // Use Clipboard API
      setCopiedMessage(text); // Set the copied message for the tooltip
  };

  const fetchChatHistory = async () => {
    try {
      const response = await axios.get(`${HOST_URL}/openai/history/quorra`); // Replace 'quorra' with dynamic username if needed
      setChatHistory(response.data);
      setShowHistoryTable(true);
    } catch (error) {
      console.error("Error fetching chat history:", error);
    }
  };

  return (

    

    <Box m="1.5rem 2.5rem"    >
      <FlexBetween>
        <Header title="CytoGPT" subtitle="AgenticAI for Cell Biology" />
        <Box>
          <Button
            sx={{
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.background.alt,
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              '&:hover': { // Add hover styles
                backgroundColor: theme.palette.secondary.light, 
                opacity: [0.9, 0.8, 0.7], // optional: add some opacity change
              },
            }}
          >
            <DownloadOutlined sx={{ mr: "10px" }} />
            Download
          </Button>
        </Box>

        <Button
            sx={{
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.background.alt,
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              '&:hover': { // Add hover styles
                backgroundColor: theme.palette.secondary.light, 
                opacity: [0.9, 0.8, 0.7], // optional: add some opacity change
              },
            }}
            onClick={fetchChatHistory}
          >
            <TableChartOutlined sx={{ mr: "10px" }} />
            History
          </Button>
      </FlexBetween>

        <Box
          gridColumn="span 8"
          gridRow="span 3"
          height="40vh"

          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
              borderRadius: "5rem",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: theme.palette.background.alt,
              color: theme.palette.secondary[100],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: theme.palette.background.alt,
            },
            "& .MuiDataGrid-footerContainer": {
              backgroundColor: theme.palette.background.alt,
              color: theme.palette.secondary[100],
              borderTop: "none",
            },
            "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
              color: `${theme.palette.secondary[200]} !important`,
            },
          }}
        >
          <DataGrid
            loading={isLoading || !data}
            getRowId={(row) => row._id}
            rows={(data && data.chatmessages) || []}
            columns={columns}

            pagination
            page={page}
            pageSize={pageSize}
            paginationMode="server"
            sortingMode="server"
            onPageChange={(newPage) => setPage(newPage)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            onSortModelChange={(newSortModel) => setSort(...newSortModel)}
            components={{ Toolbar: DataGridCustomToolbar }}
            componentsProps={{
              toolbar: { searchInput, setSearchInput, setSearch },
            }}
          />
        </Box>

      {showHistoryTable && (
        <TableContainer component={Paper} style={{ marginTop: '20px' }}>
          <Table aria-label="chat history table">
            <TableHead>
              <TableRow>
                <TableCell>Username</TableCell>
                <TableCell>User Message</TableCell>
                <TableCell>Bot Response</TableCell>
                <TableCell>Created At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chatHistory.map((row) => (
                <TableRow key={row._id}>
                  <TableCell component="th" scope="row">
                    {row.username}
                  </TableCell>
                  <TableCell>{row.userMessage}</TableCell>
                  <TableCell>{row.botResponse}</TableCell>
                  <TableCell>{new Date(row.timestamp).toLocaleString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      
      {/* GPT SECTION */}
      <Box
        mt="20px" flexGrow="1"  display="flex" flexDirection="column" // Stack elements vertically
        gridTemplateColumns="repeat(12, 1fr)" gridAutoRows="160px" gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}  >
        <Box flexGrow="1" display="flex" flexDirection="column" // Stack elements vertically
          gridColumn="span 12" gridRow="span 6"
          backgroundColor={theme.palette.background.alt}
          p="1.5rem" borderRadius="0.55rem" >
          <h3 className='text-xl font-semibold text-orange-400 mb-3'>CytoGPT</h3>
          <div className="conversation" ref={conversationRef}
            style={{
              flexGrow: 1, // Allow conversation to grow and fill space
              overflowY: "auto",
            }}  > 
            {conversation.map((entry, index) => (
                <div key={index} className={`message ${entry.role}`}>
                  <strong>{entry.role === "user" ? "You: " : <FaRobot />}</strong>
                  <ReactMarkdown remarkPlugins={[remarkBreaks, remarkGfm]} >
                    {entry.content}
                  </ReactMarkdown>

                  {( // Only show copy button for assistant messages
                      <Tooltip title={copiedMessage === entry.content ? "Copied!" : "Copy"}>
                          <IconButton className={`message ${entry.role}`}
                            onClick={() => handleCopy(entry.content)} aria-label="copy" >
                              <ContentCopy />
                          </IconButton>
                      </Tooltip>
                    )}
                </div>
            ))}
            {isAITyping && (
              <div className="message assistant">
                <FaRobot className="send-bot icon-spin" />
                <strong>AI is processing ...</strong>
              </div>
            )}
          </div>

          <div className="input-area" style={{ marginTop: "auto" }}>
			    <input type="text"
            placeholder="Enter message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="input-message"
            onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
          />
				<button
					onClick={handleSendMessage}
					disabled={mutation.isPending}
					className="send-btn" >
					{mutation.isPending ? <IoSend className="icon-spin" /> : <IoSend />}
				</button>
			</div>

      
        </Box>
      </Box>

    </Box>
  );
};
export default CytoGPT;
